import { Terminal } from "./Terminal";

export default function Hero() {
  return (
    <section className="bg-tgc-oxblood px-6 sm:px-10 md:px-[14%] py-12 md:py-20">
      <div className="relative z-10 max-w-2xl mx-auto">
        <Terminal
          theme="cream"
          tagline="A weekly standup where we talk all things tech. Careers, code, and the realities of being a woman in STEM."
          ctaLabel="latest episode"
        />
      </div>
    </section>
  );
}
